module.exports = __webpack_public_path__ + "static/media/BY.4504044f.png";